import {
  FourViewConfigType,
  SceneViewConfigType,
  PointGroupType,
  PanoramicVideoType,
  ProductMainVideoListType,
} from './typings';
// import PanoramicConfigType from './typing';

/**
 * @description 判断当前套餐是否为标准套餐
 */
const isProductStandardCid = (pid: number, cid: number): boolean => {
  const config: Record<number, number[]> = {
    26: [2994, 3005],
  };
  return config[pid]?.includes(cid);
};

/**
 * @description 获取套餐的四视图配置
 */
const getFourviewConfig = (pid: number, isMobile: boolean): FourViewConfigType | null => {
  const FOURVIEW_CONFIG: Record<number, FourViewConfigType> = {
    26: {
      startVideo: isMobile
        ? 'https://media.insta360.com/static/c212314bdffc00af1dd1bbb5a475846f/%E5%BC%80%E5%9C%BA%E5%8A%A8%E7%94%BB3480-2270_2%E5%80%8D_medium.mp4'
        : 'https://media.insta360.com/static/c212314bdffc00af1dd1bbb5a475846f/%E5%BC%80%E5%9C%BA%E5%8A%A8%E7%94%BB3480-2270_2%E5%80%8D_xlarge.mp4',
      startPoster: isMobile
        ? 'https://res.insta360.com/static/c212314bdffc00af1dd1bbb5a475846f/%E5%BC%80%E5%9C%BA%E5%8A%A8%E7%94%BB3480-2270_2%E5%80%8D_medium.jpg'
        : 'https://res.insta360.com/static/c212314bdffc00af1dd1bbb5a475846f/%E5%BC%80%E5%9C%BA%E5%8A%A8%E7%94%BB3480-2270_2%E5%80%8D_xlarge.jpg',
      ani36Fps: [
        'https://res.insta360.com/static/338a8405bc5d902f0089a4d7f0773e22/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00000.jpg',
        'https://res.insta360.com/static/af01c717f7b88da78206bd378134a84a/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00001.jpg',
        'https://res.insta360.com/static/0fc308eaf72a2a656bcea7769956e6ef/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00002.jpg',
        'https://res.insta360.com/static/9712e886b63aff05bdf89c7f22352033/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00003.jpg',
        'https://res.insta360.com/static/d947c206ee7cbc7e0e51f6425c0fa0fe/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00004.jpg',
        'https://res.insta360.com/static/63aaeda3dc8da4a14044922c9617d58a/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00005.jpg',
        'https://res.insta360.com/static/63aeac54435d1334d2a8794deaeb91ac/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00006.jpg',
        'https://res.insta360.com/static/7e036f324ed1fc4f179b4bbeaf770445/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00007.jpg',
        'https://res.insta360.com/static/604da221697dab8cde127d0c56e742d7/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00008.jpg',
        'https://res.insta360.com/static/1e6b06a18a89b3be05831aebd6f71cbc/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00009.jpg',
        'https://res.insta360.com/static/4a8a1285616cd048e16ddb2c82f922f2/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00010.jpg',
        'https://res.insta360.com/static/2bac31751d14dbd596e842359ed59850/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00011.jpg',
        'https://res.insta360.com/static/3b6013e3ea48462c2b51bebfde3f2121/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00012.jpg',
        'https://res.insta360.com/static/94fbdb944a2f512a11ebdd2c44d128fc/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00013.jpg',
        'https://res.insta360.com/static/0e8423606d73998db8a4fe595f44dcf1/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00014.jpg',
        'https://res.insta360.com/static/3793dd25bcbe2a47236f69198b73ca86/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00015.jpg',
        'https://res.insta360.com/static/26fe3f6436f5a1972b559ac1308bd006/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00016.jpg',
        'https://res.insta360.com/static/7bf9993cf72e7ba884d1c2565144a5c7/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00017.jpg',
        'https://res.insta360.com/static/f2e7cb4d27ad45d1043449d2b8871ed4/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00018.jpg',
        'https://res.insta360.com/static/be6608dfdf2ea2c817e5ac3e9e8e341c/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00019.jpg',
        'https://res.insta360.com/static/b84d7d08ee339973b76e144cd52533bd/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00020.jpg',
        'https://res.insta360.com/static/357c70ac127b9ce09320b300409334ea/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00021.jpg',
        'https://res.insta360.com/static/4ce4b67750dc419a2d3920cc7f325f87/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00022.jpg',
        'https://res.insta360.com/static/fac95da0d023b6242767836555a078e8/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00023.jpg',
        'https://res.insta360.com/static/bab547d8568cfccb9f672d0bf649f084/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00024.jpg',
        'https://res.insta360.com/static/367f288bcf7ce9c3d0c44468ea8ffaf8/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00025.jpg',
        'https://res.insta360.com/static/9704abe7f700a7d1a09a0fd8a456189d/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00026.jpg',
        'https://res.insta360.com/static/1ec447eba8005a278e1f0648a11286fa/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00027.jpg',
        'https://res.insta360.com/static/53162ee43b42274b22b864bb7777f03b/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00028.jpg',
        'https://res.insta360.com/static/f4e3d235577a690cc9bb49702ab88b93/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00029.jpg',
        'https://res.insta360.com/static/4967a97acabed232f011d7f32e12fe69/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00030.jpg',
        'https://res.insta360.com/static/3bb116395c768d5813abf515b716986a/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00031.jpg',
        'https://res.insta360.com/static/2e1beca348571450e88e2f51a46b1b33/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00032.jpg',
        'https://res.insta360.com/static/bad0b32274325723646a7fb55c886379/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00033.jpg',
        'https://res.insta360.com/static/2b9d007a14e06b0c3ecd0aaebdd73055/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00034.jpg',
        'https://res.insta360.com/static/e756ed303265005912127ee0246511ae/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00035.jpg',
        'https://res.insta360.com/static/1b17d0fb8084bc27612b4ac0928381bf/%E6%97%8B%E8%BD%AC%E5%8A%A8%E7%94%BB%203480-2270_00036.jpg',
      ],
    },
  };
  if (pid === 26) {
    return FOURVIEW_CONFIG[pid];
  }
  return null;
};

/**
 * @description 获取场景套餐的配置
 */
const getSceneviewConfig = (pid: number, cid: number, isMobile: boolean): SceneViewConfigType | null => {
  const SCENEVIEW_CONFIG: Record<number, Map<number[], SceneViewConfigType>> = {
    26: new Map([
      // 苹果套餐
      [
        [3905],
        {
          startVideo: isMobile
            ? 'https://media.insta360.com/static/a2e54d16abcb43f59b2783643808ae31/%E8%8B%B9%E6%9E%9C%E5%A5%97%E9%A4%90%E5%BC%80%E5%9C%BA%E5%8A%A8%E7%94%BB_medium.mp4'
            : 'https://media.insta360.com/static/a2e54d16abcb43f59b2783643808ae31/%E8%8B%B9%E6%9E%9C%E5%A5%97%E9%A4%90%E5%BC%80%E5%9C%BA%E5%8A%A8%E7%94%BB_xlarge.mp4',
          startPoster: isMobile
            ? 'https://res.insta360.com/static/a2e54d16abcb43f59b2783643808ae31/%E8%8B%B9%E6%9E%9C%E5%A5%97%E9%A4%90%E5%BC%80%E5%9C%BA%E5%8A%A8%E7%94%BB_medium.jpg'
            : 'https://res.insta360.com/static/a2e54d16abcb43f59b2783643808ae31/%E8%8B%B9%E6%9E%9C%E5%A5%97%E9%A4%90%E5%BC%80%E5%9C%BA%E5%8A%A8%E7%94%BB_xlarge.jpg',
          pointList: [
            {
              y: 3,
              x: isMobile ? -19 : -13,
              relateAccessoryIndex: getCommodity_point_index(pid, cid, 2986),
            },
          ],
          sceneImg: isMobile
            ? 'https://res.insta360.com/static/d1d2ba9c4ddb17058bb723d4bedb19f3/%E6%96%B0%E5%A5%97%E9%A4%90%E5%BC%80%E5%9C%BA%E8%A7%86%E9%A2%91_MOB.jpg'
            : 'https://res.insta360.com/static/0496e2e00eb535753626f1b6d38460ea/%E8%8B%B9%E6%9E%9C%E5%A5%97%E9%A4%90%E5%BC%80%E5%9C%BA%E5%8A%A8%E7%94%BB.jpg',
        },
      ],

      // 便携创作套餐（Peter McKinnon 联名版） Pro Bundle
      [
        [3691, 3692],
        {
          startVideo: isMobile
            ? 'https://media.insta360.com/static/0e2773e685185216a1841ad845413912/ProBundle%E6%B5%B7%E5%A4%96%E5%9C%B0%E5%8C%BAMOB_medium.mp4'
            : 'https://media.insta360.com/static/94cbddd48be1ad59f0b39f46d45dc669/ProBundle%E6%B5%B7%E5%A4%96%E5%9C%B0%E5%8C%BAPC_xlarge.mp4',
          startPoster: isMobile
            ? 'https://res.insta360.com/static/0e2773e685185216a1841ad845413912/ProBundle%E6%B5%B7%E5%A4%96%E5%9C%B0%E5%8C%BAMOB_medium.jpg'
            : 'https://res.insta360.com/static/94cbddd48be1ad59f0b39f46d45dc669/ProBundle%E6%B5%B7%E5%A4%96%E5%9C%B0%E5%8C%BAPC_xlarge.jpg',
          sceneImg: isMobile
            ? 'https://res.insta360.com/static/d96416af89d6f5b309cc86ebcb8dd563/ProBundle%E6%B5%B7%E5%A4%96%E5%9C%B0%E5%8C%BAMOB.jpg'
            : 'https://res.insta360.com/static/7ba7c887e5e718f6d4cf40549bf23744/ProBundle%E6%B5%B7%E5%A4%96%E5%9C%B0%E5%8C%BAPC.jpg',
        },
      ],
      //房产套餐 Virtual Tour Bundle
      [
        [3393, 3394],
        {
          startVideo: isMobile
            ? 'https://media.insta360.com/static/824f2cab8a1b87c41da7a3d46c8f2ee0/VirtualTourBundleMOB_medium.mp4'
            : 'https://media.insta360.com/static/8d404ef500dfbf2364906f93b757bc07/VirtualTourBundlePC_xlarge.mp4',
          startPoster: isMobile
            ? 'https://res.insta360.com/static/824f2cab8a1b87c41da7a3d46c8f2ee0/VirtualTourBundleMOB_medium.jpg'
            : 'https://res.insta360.com/static/8d404ef500dfbf2364906f93b757bc07/VirtualTourBundlePC_xlarge.jpg',
          pointList: [
            {
              y: isMobile ? 37 : 28,
              x: isMobile ? 2 : 2,
              relateAccessoryIndex: getCommodity_point_index(pid, cid, 2141),
            },
          ],
          sceneImg: isMobile
            ? 'https://res.insta360.com/static/e543c3246c0b77888fb22f3b6a437449/VirtualTourBundleMOB.jpg'
            : 'https://res.insta360.com/static/cd00c90ccad2b6f2cb9dff68182806f1/VirtualTourBundlePC.jpg',
        },
      ],
      //公路骑行套餐（分体把） Road Cycling Bundle (Independent)
      [
        [3397, 3398],
        {
          startVideo: isMobile
            ? 'https://media.insta360.com/static/ce38279bffab9d6095c3930f5e498f7d/RoadCyclingBundleIndependentMOB_medium.mp4'
            : 'https://media.insta360.com/static/c28a55866d818de7813fb26ce8b518e4/RoadCyclingBundleIndependentPC_xlarge.mp4',
          startPoster: isMobile
            ? 'https://res.insta360.com/static/ce38279bffab9d6095c3930f5e498f7d/RoadCyclingBundleIndependentMOB_medium.jpg'
            : 'https://res.insta360.com/static/c28a55866d818de7813fb26ce8b518e4/RoadCyclingBundleIndependentPC_xlarge.jpg',
          pointList: [
            {
              y: isMobile ? 11 : 4,
              x: isMobile ? 12 : 12,
              relateAccessoryIndex: getCommodity_point_index(pid, cid, 3444),
            },
          ],
          sceneImg: isMobile
            ? 'https://res.insta360.com/static/f818252374287c540dc213cff73505e2/RoadCyclingBundleIndependentMOB.jpg'
            : 'https://res.insta360.com/static/ba3a0dff15e30d92ece225119699d9db/RoadCyclingBundleIndependentPC.jpg',
        },
      ],

      //公路骑行套餐（一体把） Road Cycling Bundle (Integrated)
      [
        [3395, 3396],
        {
          startVideo: isMobile
            ? 'https://media.insta360.com/static/6535adeda9612b74eec93bfa4c9f01be/RoadCyclingBundleIntegratedMOB_medium.mp4'
            : 'https://media.insta360.com/static/d2a4ab0d02b7506e96a7ba9e35eed5ef/RoadCyclingBundleIntegratedPC_xlarge.mp4',
          startPoster: isMobile
            ? 'https://res.insta360.com/static/a45b946c017badf962a41147d1bd9c24/RoadCyclingBundleIntegratedMOB_medium.jpg'
            : 'https://res.insta360.com/static/d2a4ab0d02b7506e96a7ba9e35eed5ef/RoadCyclingBundleIntegratedPC_xlarge.jpg',
          pointList: [
            {
              y: isMobile ? 19.5 : 10.5,
              x: isMobile ? 32 : 30,
              relateAccessoryIndex: getCommodity_point_index(pid, cid, 3443),
            },
          ],
          sceneImg: isMobile
            ? 'https://res.insta360.com/static/e0ada377cc2182a437cab4de869e5d4e/RoadCyclingBundleIntegratedMOB.jpg'
            : 'https://res.insta360.com/static/ffa2fa8d108ab569502dc2a192afa683/RoadCyclingBundleIntegratedPC.jpg',
        },
      ],
      //双板滑雪套餐 Ski Bundle
      [
        [3000, 3011],
        {
          startVideo: isMobile
            ? 'https://media.insta360.com/static/6253ee863183e5872047c8d206856d0e/SkiBundleMOB_medium.mp4'
            : 'https://media.insta360.com/static/bf2ca6a16ed1b701ba79a3a22bcae188/SkiBundlePC_xlarge.mp4',
          startPoster: isMobile
            ? 'https://res.insta360.com/static/6253ee863183e5872047c8d206856d0e/SkiBundleMOB_medium.jpg'
            : 'https://res.insta360.com/static/bf2ca6a16ed1b701ba79a3a22bcae188/SkiBundlePC_xlarge.jpg',
          pointList: [
            {
              y: isMobile ? 1 : 0,
              x: isMobile ? 0 : -4,
              relateAccessoryIndex: getCommodity_point_index(pid, cid, 2844),
            },
            {
              y: isMobile ? 11.5 : 6.5,
              x: isMobile ? 26 : 12,
              relateAccessoryIndex: getCommodity_point_index(pid, cid, 2601),
            },
          ],
          sceneImg: isMobile
            ? 'https://res.insta360.com/static/3a72616a0e2750f3ebd1b64db077f2c2/SkiBundleMOB.jpg'
            : 'https://res.insta360.com/static/e6c5cfeca740193acc0441b5bed86545/SkiBundlePC.jpg',
        },
      ],
      //单板滑雪套餐 Snowboard Bundle
      [
        [2999, 3010],
        {
          startVideo: isMobile
            ? 'https://media.insta360.com/static/9289e619f8e9041ac4c127119e17f1d2/SnowboardBundleMOB_medium.mp4'
            : 'https://media.insta360.com/static/3d5b17af62a86c9190fb6958baf75350/SnowboardBundlePC_xlarge.mp4',
          startPoster: isMobile
            ? 'https://res.insta360.com/static/9289e619f8e9041ac4c127119e17f1d2/SnowboardBundleMOB_medium.jpg'
            : 'https://res.insta360.com/static/3d5b17af62a86c9190fb6958baf75350/SnowboardBundlePC_xlarge.jpg',
          pointList: [
            {
              y: isMobile ? 1 : 0,
              x: isMobile ? 29 : 14,
              relateAccessoryIndex: getCommodity_point_index(pid, cid, 2601),
            },
          ],
          sceneImg: isMobile
            ? 'https://res.insta360.com/static/b9b7cbd41e99490df72197f61cb84cb3/SnowboardBundleMOB.jpg'
            : 'https://res.insta360.com/static/c96e28edd7d8be87a6ad35236d52f7ab/SnowboardBundlePC.jpg',
        },
      ],
      //全能创作套餐 Creator Bundle
      [
        [3003, 3014],
        {
          startVideo: isMobile
            ? 'https://media.insta360.com/static/b7b252cf5ee1c2693ccbcd5c235609e5/CreatorBundleMOB_medium.mp4'
            : 'https://media.insta360.com/static/adc71b19c772f13275c08da987d30849/CreatorBundlePC_xlarge.mp4',
          startPoster: isMobile
            ? 'https://res.insta360.com/static/b7b252cf5ee1c2693ccbcd5c235609e5/CreatorBundleMOB_medium.jpg'
            : 'https://res.insta360.com/static/adc71b19c772f13275c08da987d30849/CreatorBundlePC_xlarge.jpg',
          pointList: [
            {
              y: isMobile ? -7.5 : -12.5,
              x: isMobile ? -16.5 : -5.5,
              relateAccessoryIndex: getCommodity_point_index(pid, cid, 183),
            },
          ],
          sceneImg: isMobile
            ? 'https://res.insta360.com/static/b24d73f4ff6bb66386532ba38e30fccc/CreatorBundleMOB.jpg'
            : 'https://res.insta360.com/static/eb66376b5fd24fd55500f188dbe4aec9/CreatorBundlePC.jpg',
        },
      ],
      //高能续航套餐 Endurance Bundle
      [
        [3002, 3013],
        {
          startVideo: isMobile
            ? 'https://media.insta360.com/static/ecbc34882c406277457d02c1998cbca8/EnduranceBundleMOB_medium.mp4'
            : 'https://media.insta360.com/static/4e998e95a25b784c012c4c2e06cb3fe4/EnduranceBundlePC_xlarge.mp4',
          startPoster: isMobile
            ? 'https://res.insta360.com/static/ecbc34882c406277457d02c1998cbca8/EnduranceBundleMOB_medium.jpg'
            : 'https://res.insta360.com/static/4e998e95a25b784c012c4c2e06cb3fe4/EnduranceBundlePC_xlarge.jpg',
          pointList: [
            {
              y: isMobile ? -7 : -7,
              x: isMobile ? 26 : 18,
              relateAccessoryIndex: getCommodity_point_index(pid, cid, 2983),
            },
          ],
          sceneImg: isMobile
            ? 'https://res.insta360.com/static/c3790eaf7ace09709ea5668bb54a9500/EnduranceBundleMOB.jpg'
            : 'https://res.insta360.com/static/fd03ddeca72db558f6a51cabc48f78e5/EnduranceBundlePC.jpg',
        },
      ],
      //全隐形潜水套餐 Invisible Dive Bundle
      [
        [3001, 3012],
        {
          startVideo: isMobile
            ? 'https://media.insta360.com/static/fff94393d1bf97480ff30cde3791b514/InvisibleDiveBundleMOB_medium.mp4'
            : 'https://media.insta360.com/static/5e74b3a573d2ca72b8286b823e06566d/InvisibleDiveBundlePC_xlarge.mp4',
          startPoster: isMobile
            ? 'https://res.insta360.com/static/fff94393d1bf97480ff30cde3791b514/InvisibleDiveBundleMOB_medium.jpg'
            : 'https://res.insta360.com/static/5e74b3a573d2ca72b8286b823e06566d/InvisibleDiveBundlePC_xlarge.jpg',
          pointList: [
            {
              y: isMobile ? -15 : -9,
              x: -4,
              relateAccessoryIndex: getCommodity_point_index(pid, cid, 2972),
            },
          ],
          sceneImg: isMobile
            ? 'https://res.insta360.com/static/ddaeed0ee6575973b7744f4123bc05fb/InvisibleDiveBundleMOB.jpg'
            : 'https://res.insta360.com/static/e68f1568b3445fc91ca300cb48d2577a/InvisibleDiveBundlePC.jpg',
        },
      ],
      //摩托车车把视角套餐 Motorcycle Handlebar Bundle
      [
        [3375, 3376],
        {
          startVideo: isMobile
            ? 'https://media.insta360.com/static/ebbf7248343f305c5c91dfa320c762ce/MotorcycleHandlebarBundleMOB_medium.mp4'
            : 'https://media.insta360.com/static/da8f4a66d48597e7cc4bb662b88a50c1/MotorcycleHandlebarBundlePC_xlarge.mp4',
          startPoster: isMobile
            ? 'https://res.insta360.com/static/ebbf7248343f305c5c91dfa320c762ce/MotorcycleHandlebarBundleMOB_medium.jpg'
            : 'https://res.insta360.com/static/da8f4a66d48597e7cc4bb662b88a50c1/MotorcycleHandlebarBundlePC_medium.jpg',
          pointList: [
            {
              y: isMobile ? 12 : 2,
              x: isMobile ? -0.5 : -3.5,
              relateAccessoryIndex: getCommodity_point_index(pid, cid, 2895),
            },
          ],
          sceneImg: isMobile
            ? 'https://res.insta360.com/static/acddc0dad125367aad579166e13f37df/MotorcycleHandlebarBundleMOB.jpg'
            : 'https://res.insta360.com/static/15c5ee5df9ddcd5fcb7a6f472d891ad0/MotorcycleHandlebarBundlePC.jpg',
        },
      ],

      //摩托车多视角套餐 Motorcycle Multiview Bundle
      [
        [2997, 3008],
        {
          startVideo: isMobile
            ? 'https://media.insta360.com/static/a559a7dcf63bc9623d4f3b2c6799caa5/MotorcycleMultiviewBundleMOB_medium.mp4'
            : 'https://media.insta360.com/static/8dadf9e8985af2cf36df0372f5e85ecc/okAlfgD4nBuKa8M9sGVswTQ8BA7lK07gIlIpWe.mp4',
          startPoster: isMobile
            ? 'https://res.insta360.com/static/a559a7dcf63bc9623d4f3b2c6799caa5/MotorcycleMultiviewBundleMOB_medium.jpg'
            : 'https://res.insta360.com/static/690f7275a0689f76db258518891cde33/MotorcycleMultiviewBundlePC_xlarge.jpg',
          pointList: [
            {
              y: 0,
              x: isMobile ? 7.5 : 4.5,
              relateAccessoryIndex: getCommodity_point_index(pid, cid, 2895),
            },
          ],
          sceneImg: isMobile
            ? 'https://res.insta360.com/static/81ff4f7fb3f5503e915c4c03f71cf3ef/MotorcycleMultiviewBundleMOB.jpg'
            : 'https://res.insta360.com/static/bd331fe1b008424b74275d0a57f95294/MotorcycleMultiviewBundlePC.jpg',
        },
      ],
      //摩托车全能视角套餐 Motorcycle Ultimate Multiview Bundle
      [
        [3377, 3378],
        {
          startVideo: isMobile
            ? 'https://media.insta360.com/static/e808b361b474351ac0d77418ec514973/MotorcycleUltimateMultiviBundleMOB_medium.mp4'
            : 'https://media.insta360.com/static/d8b29f327c83e0a20de1355a8083cb39/uuuu.mp4',
          startPoster: isMobile
            ? 'https://res.insta360.com/static/e808b361b474351ac0d77418ec514973/MotorcycleUltimateMultiviBundleMOB_medium.jpg'
            : 'https://res.insta360.com/static/61f2587fee86eaed0210d880f89fb1bf/MotorcycleUltimateMultivieBundlePC_large.jpg',
          pointList: [
            {
              y: isMobile ? -18 : -14,
              x: 13,
              relateAccessoryIndex: getCommodity_point_index(pid, cid, 2601),
            },
            {
              y: isMobile ? 12 : 9,
              x: isMobile ? -18 : -10,
              relateAccessoryIndex: getCommodity_point_index(pid, cid, 3630),
            },
          ],
          sceneImg: isMobile
            ? 'https://res.insta360.com/static/4b85b6116bcab04e373b5118dbe7fad0/MotorcycleUltimateMultiviBundleMOB.jpg'
            : 'https://res.insta360.com/static/566e8ec3331f23a789b0b6d67fb3495b/MotorcycleUltimateMultiviewBundlePC.jpg',
        },
      ],
      // 无人机视角套餐 No Drone No Problem Bundle
      [
        [3004, 3015],
        {
          startVideo: isMobile
            ? 'https://media.insta360.com/static/799973579b0227dbdf1f172048808cfa/NoDroneNoProblemndleMOB_medium.mp4'
            : 'https://media.insta360.com/static/503e73174b0489797a34e243598c83ed/rrrr.mp4',
          startPoster: isMobile
            ? 'https://res.insta360.com/static/799973579b0227dbdf1f172048808cfa/NoDroneNoProblemndleMOB_medium.jpg'
            : 'https://res.insta360.com/static/694b7997e84ac6ff42859d4e8bed451b/NoDroneNoProblemBundlePC_xlarge.jpg',
          pointList: [
            {
              y: isMobile ? -8 : -5,
              x: isMobile ? 1.5 : -0.5,
              relateAccessoryIndex: getCommodity_point_index(pid, cid, 1344),
            },
          ],
          sceneImg: isMobile
            ? 'https://res.insta360.com/static/be1a12b5bb3d57475909191041135630/NoDroneNoProblemndleMOB.jpg'
            : 'https://res.insta360.com/static/f7494bf3687105d626b3db10524fa8cb/NoDronmBundlePC.jpg',
        },
      ],
      // 高级保护镜套餐 Premium Lens Guards Bundle
      [
        [2996, 3007],
        {
          startVideo: isMobile
            ? 'https://media.insta360.com/static/7f2817f426a7f4d44cea554bbfd4578a/PremiumLensGuarBundleMOB_medium.mp4'
            : 'https://media.insta360.com/static/b5ed88d8bfe003df3c4b5dd47246d7ea/PremiumLensGuardsBundlePC_xlarge.mp4',
          startPoster: isMobile
            ? 'https://res.insta360.com/static/7f2817f426a7f4d44cea554bbfd4578a/PremiumLensGuarBundleMOB_medium.jpg'
            : 'https://res.insta360.com/static/b5ed88d8bfe003df3c4b5dd47246d7ea/PremiumLensGuardsBundlePC_xlarge.jpg',
          pointList: [
            {
              y: isMobile ? 14 : 9,
              x: isMobile ? -6 : -4,
              relateAccessoryIndex: getCommodity_point_index(pid, cid, 2971),
            },
          ],
          sceneImg: isMobile
            ? 'https://res.insta360.com/static/b5cf9ce8e2b98355c1952b2778ea9f18/PremiumLensGuarBundleMOB.jpg'
            : 'https://res.insta360.com/static/46a9e5a81226de3163c11eb311ff6bc2/PremiumLensGuardsBundlePC.jpg',
        },
      ],
      // 骑行套餐 Bike Bundle
      [
        [2998, 3009],
        {
          startVideo: isMobile
            ? 'https://media.insta360.com/static/592de1ed0a2794e7ce1e93b7e42c3c31/BikeBundleMOB_medium.mp4'
            : 'https://media.insta360.com/static/82b50480fb7bf5572fdd67759a50c367/BikeBundlePC_xlarge.mp4',
          startPoster: isMobile
            ? 'https://res.insta360.com/static/592de1ed0a2794e7ce1e93b7e42c3c31/BikeBundleMOB_medium.jpg'
            : 'https://res.insta360.com/static/82b50480fb7bf5572fdd67759a50c367/BikeBundlePC_xlarge.jpg',
          pointList: [
            {
              y: isMobile ? -3 : -1,
              x: isMobile ? 6.5 : 2.5,
              relateAccessoryIndex: getCommodity_point_index(pid, cid, 2287),
            },
          ],
          sceneImg: isMobile
            ? 'https://res.insta360.com/static/1ed85337ac9b76cbf75e341a04df7588/BikeBundleMOB.jpg'
            : 'https://res.insta360.com/static/ceb2298cb32a5da87d9af60c4085d945/BikeBundlePC.jpg',
        },
      ],
      // BMW Motorrad 限定款 BMW Motorrad Edition
      [
        [3647, 3648],
        {
          startVideo: isMobile
            ? 'https://media.insta360.com/static/c3500487557cdbcbc237e3015f61ee52/BMWMotorradEditionMOB_medium.mp4'
            : 'https://media.insta360.com/static/c81d9e102eb30181ac983bb0d5392a55/BMWMotorradEditionPC_xlarge.mp4',
          startPoster: isMobile
            ? 'https://res.insta360.com/static/c3500487557cdbcbc237e3015f61ee52/BMWMotorradEditionMOB_medium.jpg'
            : 'https://res.insta360.com/static/c81d9e102eb30181ac983bb0d5392a55/BMWMotorradEditionPC_xlarge.jpg',
          sceneImg: isMobile
            ? 'https://res.insta360.com/static/286b520bbc74e3496d50141c16a67fc3/BMWMotorradEditionMOB.jpg'
            : 'https://res.insta360.com/static/7601dc130799bb7dae5efa7949226f8a/BMWMotorradEditionPC.jpg',
        },
      ],

      // 人气套餐 Get-Set Bundle
      [
        [2995, 3006],
        {
          startVideo: isMobile
            ? 'https://media.insta360.com/static/3aa91094c4c2e8044f8490813dbf1959/GetSetBundleMOB_medium.mp4'
            : 'https://media.insta360.com/static/745be7d6d0a663771290f4e72c140238/GetSetBundlePC_xlarge.mp4',
          startPoster: isMobile
            ? 'https://res.insta360.com/static/3aa91094c4c2e8044f8490813dbf1959/GetSetBundleMOB_medium.jpg'
            : 'https://res.insta360.com/static/745be7d6d0a663771290f4e72c140238/GetSetBundlePC_xlarge.jpg',
          pointList: [
            {
              y: isMobile ? -4 : 0,
              x: isMobile ? 29.5 : 16.5,
              relateAccessoryIndex: getCommodity_point_index(pid, cid, 2141),
            },
          ],
          sceneImg: isMobile
            ? 'https://res.insta360.com/static/c5262f27360aa68c65832e1af71f9796/GetSetBundleMOB.jpg'
            : 'https://res.insta360.com/static/15e1cb3e44097acb0b12d23fc55a6894/GetSetBundlePC.jpg',
        },
      ],
    ]),
  };

  if (!SCENEVIEW_CONFIG[pid]) return null;

  // 输出场景套餐的配置
  for (const [cids, config] of SCENEVIEW_CONFIG[pid]) {
    if (cids.includes(cid)) {
      return config;
    }
  }
  return null;
};

/**
 * @description 获取配件场景的配置
 */
/** 特殊的套餐 - 无配件 展示场景图 */
export const SPECIAL_COMMODITY = new Set([2994, 3647, 3005, 3648]);

// 正常套餐 所属配件
function getCommodityPointList(pid: number, cid: number): number[] | PointGroupType[] {
  const pointList: Record<number, Map<number[], number[] | PointGroupType[]>> = {
    26: new Map([
      // 苹果套餐
      [[3905], [2983, 2986]],
      // 人气无卡、有卡
      [
        [2995, 3006],
        [2976, 2141],
      ],
      // 高级保护镜无卡、有卡
      [
        [2996, 3007],
        [2976, 2141, 2971],
      ],
      // 骑行无卡、有卡
      [
        [2998, 3009],
        [2976, 2141, 2287],
      ],
      // 单板滑雪无卡、有卡
      [
        [2999, 3010],
        [2976, 2601],
      ],
      // 双板滑雪无卡、有卡
      [
        [3000, 3011],
        [2976, 2601, 2844],
      ],
      // 全隐形潜水无卡、有卡
      [
        [3001, 3012],
        [2976, 2141, 2972, 2872, 2889],
      ],
      // 高能续航无卡、有卡
      [
        [3002, 3013],
        [2976, 2986, 2983, 2982, 2981],
      ],
      // 全能创作无卡、有卡
      [
        [3003, 3014],
        [2976, 183, 1343, 2973, 2974],
      ],
      // 无人机视角无卡、有卡
      [
        [3004, 3015],
        [2976, 1344],
      ],
      // 摩托车车把视角无卡、有卡
      [[3375, 3376], [2895]],
      // 摩托车多视角无卡、有卡
      [
        [2997, 3008],
        [2976, 2601, 2895],
      ],
      // 摩托车全能视角无卡、有卡
      [
        [3377, 3378],
        [2976, 2601, 2895, 3630, 2854],
      ],
      // 公路骑行套餐（一体把）无卡、有卡
      [
        [3395, 3396],
        [2976, 2141, 3443],
      ],
      // 公路骑行套餐（分体把）无卡、有卡
      [
        [3397, 3398],
        [2976, 2141, 3444],
      ],
      // 房产套餐无卡、有卡
      [
        [3393, 3394],
        [2976, 2141, 851],
      ],
      // 便携创作套餐（Peter McKinnon 联名版）有卡
      [[3691], [2976, 3785, 2983, 3786]],
      // 标准无卡、宝马无卡
      [[2994, 3647, 3005, 3648], []],
    ]),
  };

  if (!pointList[pid]) return [];

  for (const [cids, point] of pointList[pid]) {
    if (cids.includes(cid)) {
      return point;
    }
  }

  return [];
}

/** 获取某个配件场景图下标 */
const getCommodity_point_index = (pid: number, cid: number, ac_cid: number) => {
  const pointList = getCommodityPointList(pid, cid);
  return pointList?.findIndex((id) => id === ac_cid) ?? undefined;
};

/** 配件场景数据 */
export const getCommodityAccessoryList = (
  cid: number,
  cName: string,
  isMobile: boolean,
  LANG: Record<string, string>,
  pid: number
): PointGroupType[] => {
  /** get 合集图 */
  const overviewPic = getCurOverViewPic(pid, cid, cName, isMobile);
  /** get 当前产品套餐所属配件id */
  const accessory = getCommodityPointList(pid, cid);
  /** get配件详情 */
  const accessoriesList = getAccessoriesList(LANG, pid);

  /** 如果是特殊套餐，直接返回 */
  if (SPECIAL_COMMODITY.has(cid)) {
    if (isMobile) {
      /** 移动端去掉场景图 只保留合集图 */
      accessory.splice(0, accessory.length);
    }
    return [...overviewPic, ...(accessory as PointGroupType[])];
  }

  /** 正常套餐过滤出配件信息 */
  const list: PointGroupType[] = accessory
    .map((sk) => accessoriesList.find((item) => item.id === sk))
    .filter(Boolean) as PointGroupType[];
  /** 场景套餐再过滤一次 */
  const newList = getSceneAccessories(pid, cid, list);

  return [...overviewPic, ...newList];
};

/** 合集图 */
function getCurOverViewPic(pid: number, cid: number, name: string, isMobile: boolean): PointGroupType[] {
  const pc_imgs: Record<number, string> = {
    // 无内存卡
    2994: 'https://res.insta360.com/static/ca12b4d659d9f499d4a375092e1ce090/1.%20Standard%20Bundle-2994.jpg',
    2995: 'https://res.insta360.com/static/f4cbfa6276d07c774103bd7bd9993634/11.%20Get-Set%20Bundle-2995.jpg',
    2996: 'https://res.insta360.com/static/e16b5c0e514be890b8294d7116552e7e/16.%20Premium%20Lens%20Guards%20Bundle-2996.jpg',
    2998: 'https://res.insta360.com/static/fd596972ba07979d120ddd42e1e5425a/14.%20Bike%20Bundle-2998.jpg',
    2999: 'https://res.insta360.com/static/fe2ef748f8d8b58aee5f63c14814c9ee/7.%20Snowboard%20Bundle-2999.jpg',
    3000: 'https://res.insta360.com/static/915c668e1dc18dfdf7ebbce22361a755/8.%20Ski%20Bundle-3000.jpg',
    3001: 'https://res.insta360.com/static/ab88b69283fbd3d1bc00e392f649435b/3.%20Invisible%20Dive%20Bundle-3001.jpg',
    3002: 'https://res.insta360.com/static/10edf633be103bbb70f1891ed949af46/12.%20Endurance%20Bundle-3002.jpg',
    3003: 'https://res.insta360.com/static/b3e11e7af13d76a2ff5bca10d6be2e6d/17.%20Creator%20Bundle-3003.jpg',
    3004: 'https://res.insta360.com/static/18990d3cb4606104d56ad56f2abcb2c7/13.%20No%20Drone%20No%20Problem%20Bundle-3004.jpg',
    3375: 'https://res.insta360.com/static/34b2e44e93f6ae72b06a8d9bd33b5cf1/4.%20Motorcycle%20Handlebar%20Bundle-3375.jpg',
    2997: 'https://res.insta360.com/static/551b02ffeac84e9ad0065d86fe435a7b/5.%20Motorcycle%20Multiview%20Bundle-2997.jpg',
    3377: 'https://res.insta360.com/static/a595121125070fa462a647cc87380652/6.%20Motorcycle%20Ultimate%20Multiview%20Bundle-3377.jpg',
    3395: 'https://res.insta360.com/static/349f321b8043fdb1f20cdc1adc900bc6/9.%20Road%20Cycling%20Bundle%20(Integrated)-3395.jpg',
    3397: 'https://res.insta360.com/static/161bed7ee6de2cd53de75fa9054a0c90/10.%20Road%20Cycling%20Bundle%20(Independent)-3397.jpg',
    3393: 'https://res.insta360.com/static/875636ea6b052d181283282eb7a0cb47/15.%20Virtual%20Tour%20Bundle-3393.jpg',
    3647: 'https://res.insta360.com/static/41a1f0de7a00a358d343cfa2993bad5b/2.%20BMW%20Motorrad%20Edition-3647.jpg',
    // 有内存卡
    3691: 'https://res.insta360.com/static/495ed4f2d95e2daf0afb3b10c081f900/18.%20Pro%20Bundle%20(Peter%20McKinnon%20Edition)-3691.jpg',
    3005: 'https://res.insta360.com/static/05478d74f96b2436ca2110517a1fdc21/1.%20Standard%20Bundle-3005.jpg',
    3006: 'https://res.insta360.com/static/811a4aebef98c4a403ad50ae4bd92b12/11.%20Get-Set%20Bundle-3006.jpg',
    3007: 'https://res.insta360.com/static/5e17b2df1fa48e028d6d55a12cae9e9a/16.%20Premium%20Lens%20Guards%20Bundle-3007.jpg',
    3376: 'https://res.insta360.com/static/4910a2b1e87dc2e835d11a4043913c8c/4.%20Motorcycle%20Handlebar%20Bundle-3376.jpg',
    3008: 'https://res.insta360.com/static/8b407c60708aad921c93dbc26404e82d/5.%20Motorcycle%20Multiview%20Bundle-3008.jpg',
    3378: 'https://res.insta360.com/static/623c955a70f5b98e2879557a1765f5a4/6.%20Motorcycle%20Ultimate%20Multiview%20Bundle-3378.jpg',
    3009: 'https://res.insta360.com/static/28670b6d8d27790d996889b7e4867474/14.%20Bike%20Bundle-3009.jpg',
    3010: 'https://res.insta360.com/static/ee172e5032eb85c03919949343cfa138/7.%20Snowboard%20Bundle-3010.jpg',
    3011: 'https://res.insta360.com/static/059a95a1684a3553053bf97eb22c7ac9/8.%20Ski%20Bundle-3011.jpg',
    3012: 'https://res.insta360.com/static/24a23cee902957847a307f699669cc74/3.%20Invisible%20Dive%20Bundle-3012.jpg',
    3013: 'https://res.insta360.com/static/ea322a519982c71526c0acfce151db90/12.%20Endurance%20Bundle-3013.jpg',
    3014: 'https://res.insta360.com/static/1375bc8fdcbe33a5947cac4f6d46bda6/17.%20Creator%20Bundle-3014.jpg',
    3015: 'https://res.insta360.com/static/11c610ff69706c2a98f8d323411848f8/13.%20No%20Drone%20No%20Problem%20Bundle-3015.jpg',
    3396: 'https://res.insta360.com/static/b51ddddf54bf54e971094eccab994d00/9.%20Road%20Cycling%20Bundle%20(Integrated)-3396.jpg',
    3398: 'https://res.insta360.com/static/db44653eebbb0fbc0b74b985ded4af53/10.%20Road%20Cycling%20Bundle%20(Independent)-3398.jpg',
    3394: 'https://res.insta360.com/static/9098caeedb361dcc7d690e4365a1c135/15.%20Virtual%20Tour%20Bundle-3394.jpg',
    3648: 'https://res.insta360.com/static/761ca51f77c2991462c11152a21512e1/2.%20BMW%20Motorrad%20Edition-3648.jpg',
    3905: 'https://res.insta360.com/static/6177e7ab57b4edcb8b94dfb8359e5543/19.%20Apple%20Kit%20Bundle.jpg',
  };

  const thumbnail_imgs: Record<number, string> = {
    // 无内存卡
    2994: 'https://res.insta360.com/static/0ef8b6ad3eaec20efe66b95ecc87e410/2994_EN_NONE.png',
    2995: 'https://res.insta360.com/static/d4f50bbf77f1ea62b543b5041b844190/2995_EN_NONE.png',
    2996: 'https://res.insta360.com/static/bf1587fa81389cd8285003ed45fdde2c/2996_EN_NONE.png',
    2998: 'https://res.insta360.com/static/27c44dfbf63c8a46c0e0542ed37a34cc/2998_EN_NONE.png',
    2999: 'https://res.insta360.com/static/d685fd943a38f6413dd7b7e3b133d60f/2999_EN_NONE.png',
    3000: 'https://res.insta360.com/static/4afa32ba3f4d666ddc7c445f80f805d7/3000_EN_NONE.png',
    3001: 'https://res.insta360.com/static/f11a0a801f42c67edbe4a70abc1eb6dc/3001_EN_NONE.png',
    3002: 'https://res.insta360.com/static/5372ed4c7c05ac317d56c430d25ce263/3002_EN_NONE.png',
    3003: 'https://res.insta360.com/static/0f7e45a4f7487d490545cd82ef8632d0/3003_EN_NONE.png',
    3004: 'https://res.insta360.com/static/59f36ac3e6dc119d7ff1080f6af93285/3004_EN_NONE.png',
    3375: 'https://res.insta360.com/static/846f5610d60f6e498a7a2f734d7bf8c9/3375_EN_NONE.png',
    2997: 'https://res.insta360.com/static/501d1db4aca06b65cbf0d9275b08b9a4/2997_EN_NONE.png',
    3377: 'https://res.insta360.com/static/cba538f571378af7fdd0129f45ec4d2a/3377_EN_NONE.png',
    3395: 'https://res.insta360.com/static/4b1d5d5283245c542ef0e423d05dcaa3/3395_EN_NONE.png',
    3397: 'https://res.insta360.com/static/9d7f40e6618aaea6205ec46ed3b5e4f8/3397_EN_NONE.png',
    3393: 'https://res.insta360.com/static/bf18ae0dd7b7a1af0d70900f1d7a73a4/3393_EN_NONE.png',
    3647: 'https://res.insta360.com/static/187abc6fddfc332c1c9a8f97706b2292/3647_EN_NONE.png',
    // 有内存卡
    3691: 'https://res.insta360.com/static/df7855010a06633cfc8fa17a6c68b677/3691_EN_256.png',
    3005: 'https://res.insta360.com/static/fabc61e5cbc017b62202479de4195710/3005_EN_256.png',
    3006: 'https://res.insta360.com/static/822c42f5039539f711cb68a0483ca31c/3006_EN_256.png',
    3007: 'https://res.insta360.com/static/bbf030f0e826b9cf1337b2d10a901cf2/3007_EN_256.png',
    3376: 'https://res.insta360.com/static/aafcdbee1d948218c20ad0966c8b9cd2/3376_EN_256.png',
    3008: 'https://res.insta360.com/static/1e528f34bc05822f6a3159089edf604c/3008_EN_256.png',
    3378: 'https://res.insta360.com/static/e07e76559b162e06e6c7991ae28da819/3378_EN_256.png',
    3009: 'https://res.insta360.com/static/6bfe9fca144e97652eed17e0faa2ee56/3009_EN_256.png',
    3010: 'https://res.insta360.com/static/706801845f3be2889b8150b5becfab5c/3010_EN_256.png',
    3011: 'https://res.insta360.com/static/01ca43a9335268e10abcafed7c6a71cd/3011_EN_256.png',
    3012: 'https://res.insta360.com/static/602ba3d0155fee0f81557b526d6bcb2d/3012_EN_256.png',
    3013: 'https://res.insta360.com/static/9d7871aad5afb1b89fd96287e0b43313/3013_EN_256.png',
    3014: 'https://res.insta360.com/static/25333e6357ff7a51c9d287b3ad8d7ca1/3014_EN_256.png',
    3015: 'https://res.insta360.com/static/ea0800a531b055e47d571f3c76406dea/3015_EN_256.png',
    3396: 'https://res.insta360.com/static/064a1e7b4a7e13cce7d5e6f89695b79d/3396_EN_256.png',
    3398: 'https://res.insta360.com/static/8ab03d581147de142e8e33cd902bf23e/3398_EN_256.png',
    3394: 'https://res.insta360.com/static/0a40f114947ac4182221f765eec01f0c/3394_EN_256.png',
    3648: 'https://res.insta360.com/static/19f7361d203c18ab31598f28a1932e80/3648_EN_256.png',
    3905: 'https://res.insta360.com/static/e647a6af0dca3b511305c8decddacf40/%E8%8B%B9%E6%9E%9C%E5%A5%97%E9%A4%90%20256GB%E4%B8%BB%E5%9B%BE_112*112.png',
  };

  const mo_imgs: Record<number, string> = {
    // 无内存卡
    2994: 'https://res.insta360.com/static/f9f68c25bdbf9682dcd244be8af7e934/2994.png',
    2995: 'https://res.insta360.com/static/148dc55bd44caad2d756a2428e0023a1/2995.png',
    2996: 'https://res.insta360.com/static/37542fd64b23aba6d79271061075e7bd/2996.png',
    2998: 'https://res.insta360.com/static/9acd340e75df512305252aa7255eb35c/2998.png',
    2999: 'https://res.insta360.com/static/97f8f9dd59b802ab43b756fc9cdb297c/2999.png',
    3000: 'https://res.insta360.com/static/923f6367989438817e9702170956c12e/3000.png',
    3001: 'https://res.insta360.com/static/fe85ee5cb5cf502c00517b504f1befb5/3001.png',
    3002: 'https://res.insta360.com/static/330f20819975ce503f0d2b76c72c5085/3002_EN_NONE.jpg',
    3003: 'https://res.insta360.com/static/abaf8dae4198404b8def54d095e49b09/3003.png',
    3004: 'https://res.insta360.com/static/8e9501d304162a4031c344654cf73243/3004.png',
    3375: 'https://res.insta360.com/static/c4e8c140feae53b3efdd6abee7d51179/3375.png',
    2997: 'https://res.insta360.com/static/a0223fc78706e5538de832ffdfc78a0f/2997.png',
    3377: 'https://res.insta360.com/static/39e7cf2c31beeb79875368cc196f5577/3377.png',
    3395: 'https://res.insta360.com/static/a377ec17876624038a14422b72b6296c/3395.png',
    3397: 'https://res.insta360.com/static/0d2853a1339b96775f448cc37f80abd8/3397.png',
    3393: 'https://res.insta360.com/static/d426e92faff4b9a19bec10a43e764418/3393.png',
    3647: 'https://res.insta360.com/static/3d64c18b97dfbabc7588d0ef586ed478/3647.png',
    // 有内存卡
    3691: 'https://res.insta360.com/static/b9f7304a83d55ccd423139cd5334c724/3691.png',
    3005: 'https://res.insta360.com/static/c15c70bbe18b266bb893ea64e45ddf9f/3005.png',
    3006: 'https://res.insta360.com/static/7f9599570abb56a03b82d3ac1c1885da/3006.png',
    3007: 'https://res.insta360.com/static/13afd88027fa2cf2c800c9e42d700326/3007.png',
    3376: 'https://res.insta360.com/static/e1e19b7c25661e1108bd2cdad20ac95b/3376.png',
    3008: 'https://res.insta360.com/static/e52e44e162d78cdc0d6d3c31c0ecbb22/3008.png',
    3378: 'https://res.insta360.com/static/ee55b97efb111c2faac8b1506803058a/3378.png',
    3009: 'https://res.insta360.com/static/122a4da865b3f7715c8fa1999df779e5/3009.png',
    3010: 'https://res.insta360.com/static/e73d95a64a1081c2b25e886a99868f09/3010.png',
    3011: 'https://res.insta360.com/static/0d4c1acc0877308dd102f5ad9417ac58/3011.png',
    3012: 'https://res.insta360.com/static/a93c32b2218b1d54c82f8babc35d45b4/3012.png',
    3013: 'https://res.insta360.com/static/d2dde62e8b0d6e287914721a80e6cc74/3013.png',
    3014: 'https://res.insta360.com/static/11ea2319fe172973d234e2eba9471cbd/3014.png',
    3015: 'https://res.insta360.com/static/0f27e07388bf668ce099e06f489af0d0/3015.png',
    3396: 'https://res.insta360.com/static/6006331647a928b7e705347d8d7e6ba4/3396.png',
    3398: 'https://res.insta360.com/static/d5a122ae3ef88a9111891ca3a8280188/3398.png',
    3394: 'https://res.insta360.com/static/565357a5499d138d053d2270f72c602d/3394.png',
    3648: 'https://res.insta360.com/static/b0616513c08e7b872f268184f743fffc/3648.png',
    3905: 'https://res.insta360.com/static/58754c24b8a2c399c8157e12cf02bdd2/19.%20Apple%20Bundle_MO.png',
  };

  const sceneGraphList: Record<number, Record<number, string>> = {
    26: isMobile ? mo_imgs : pc_imgs,
  };

  const thumbnailList: Record<number, Record<number, string>> = {
    26: thumbnail_imgs,
  };

  const sceneGraphImgs = sceneGraphList[pid] || {};
  const thumbnailImgs = thumbnailList[pid] || {};

  if (!sceneGraphImgs[cid] || !thumbnailImgs[cid]) return [];

  return [
    {
      commodity_id: cid,
      thumbnail_url: thumbnailImgs[cid],
      sceneGraph_url: sceneGraphImgs[cid],
      commodity_name: name,
    },
  ];
}

/** 通用配件列表 */
function getAccessoriesList(LANG: Record<string, string>, pid: number): PointGroupType[] {
  const accessoriesList: Record<number, PointGroupType[]> = {
    26: [
      {
        id: 2994,
        thumbnail_url: 'https://res.insta360.com/static/c1179601f6fee51a2f3e1f4a2b743ba3/X4.png',
        sceneGraph_url: 'https://res.insta360.com/static/c1179601f6fee51a2f3e1f4a2b743ba3/X4.png',
      },
      {
        id: 183,
        thumbnail_url: 'https://res.insta360.com/static/8b59bf0673ac6a457b685e396fe9ca6a/183.png',
        sceneGraph_url: 'https://res.insta360.com/static/ebad04d0bb1a6b2ab9f181bf494f233f/SG-EN-PC-183.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/92c08bab583d865c0ea34d7dd0d0f821/SG-EN-MO-183.jpg',
      },
      {
        id: 851,
        thumbnail_url: 'https://res.insta360.com/static/17a876abaf0d8607c86255f1933ca022/851.png',
        sceneGraph_url: 'https://res.insta360.com/static/59133bf1e75cf47b1331fa718f27a868/SG-EN-PC-851.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/22ff132c62a056285afdfc0f41ee40f0/SG-EN-MO-851.jpg',
      },
      {
        id: 1343,
        thumbnail_url: 'https://res.insta360.com/static/b5516757deec123bee268e02ea8fc9f8/1343.png',
        sceneGraph_url: 'https://res.insta360.com/static/5a2ba066b99d18df88ccf3ccd7c43e36/SG-EN-PC-1343.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/bd5d8724cdc10ef4ffa54f0ae2cb2152/SG-EN-MO-1343.jpg',
      },
      {
        id: 1344,
        thumbnail_url: 'https://res.insta360.com/static/4618279d650fb833e6208fd22b44b2a8/1344.png',
        sceneGraph_url: 'https://res.insta360.com/static/660cc36cd802c81db48d45400afb70e6/SG-EN-PC-1344.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/d0f50899686f7e6e97ba664bfd6e43e3/SG-EN-MO-1344.jpg',
      },
      {
        id: 2141,
        thumbnail_url: 'https://res.insta360.com/static/4b340132987c6fde3eef00540d875d46/2141.png',
        sceneGraph_url:
          'https://res.insta360.com/static/742de2e88bc9184261d66307772f888a/4.%20114cm%E9%9A%90%E5%BD%A2%E8%87%AA%E6%8B%8D%E6%9D%86.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/9870ee036e5e0f15cffcc05f112ee4f0/SG-EN-MO-2141.jpg',
      },
      {
        id: 2287,
        thumbnail_url: 'https://res.insta360.com/static/e3609662d7298b6efae4bceaefadd9ca/2287.png',
        sceneGraph_url: 'https://res.insta360.com/static/9503567d536ada9f7c170eb3e17fe28d/SG-EN-PC-2287.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/6df26fa7ee973ab6f5b2737dd98c76fa/SG-EN-MO-2287.jpg',
      },
      {
        id: 2601,
        thumbnail_url: 'https://res.insta360.com/static/7044c4dd42f95af4f5c4c2f1e47df0c1/2601.png',
        sceneGraph_url: 'https://res.insta360.com/static/5692f515cd67f2d8b5194a6deaf3b58c/SG-EN-PC-2601.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/433458d972f85b0b5b7ce447ad2fd736/SG-EN-MO-2601.jpg',
      },
      {
        id: 2844,
        thumbnail_url: 'https://res.insta360.com/static/7a762aeddef5ac8f48fff2fc87c8c944/2844.png',
        sceneGraph_url: 'https://res.insta360.com/static/20a7eae88afa94a3bb1fa564311da321/SG-EN-PC-2844.jpeg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/35d8540bc12fc382ad19e90ac8add923/SG-EN-MO-2844.jpg',
      },
      {
        id: 2854,
        thumbnail_url: 'https://res.insta360.com/static/390a89e1c82fdebf2c7cd6f666dfc117/2854.png',
        sceneGraph_url: 'https://res.insta360.com/static/32e4fdaf91898e60b93855d5c7f4953e/SG-EN-PC-2854.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/6819dade7015ca1baf6ac858b94bad82/SG-EN-MO-2854.jpg',
      },
      {
        id: 2872,
        thumbnail_url:
          'https://res.insta360.com/static/ca61b9b891150de5a80537719a1f3bfd/%E6%B5%AE%E5%8A%9B%E6%A3%92.png',
        sceneGraph_url: 'https://res.insta360.com/static/151e77a5564df60871fb10624f1d708f/SG-EN-PC-2872.jpeg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/e8ac9412eb80b9be064205455348c667/SG-EN-MO-2872.jpg',
      },
      {
        id: 2889,
        thumbnail_url: 'https://res.insta360.com/static/eaf46f9caa26ac17fae4239b31cdad84/2889.png',
        sceneGraph_url: 'https://res.insta360.com/static/7e5a17394833508bc8279a50e499f6dd/SG-EN-PC-2889.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/c7eefb2f834efe40d5d3d119dc77be0a/SG-EN-MO-2889.jpg',
      },
      {
        id: 2895,
        thumbnail_url: 'https://res.insta360.com/static/d09ef09758accbdac012540caa5f8f19/2895.png',
        sceneGraph_url: 'https://res.insta360.com/static/988ea263354c84eba5c55911ecdbf261/SG-EN-PC-2895.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/1ef95d7553dba9febae2482ccf97b746/SG-EN-MO-2895.jpg',
      },
      {
        id: 2970,
        thumbnail_url: 'https://res.insta360.com/static/0516a99ac23c2ddb1c66abea6cc45eb9/2970.png',
        sceneGraph_url: 'https://res.insta360.com/static/1652613dba12f628ef3a5f6d09cdb7e4/SG-EN-PC-2970.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/4fd22cb91e48f3459969de90e9540882/SG-EN-MO-2970.jpg',
      },
      {
        id: 2971,
        thumbnail_url: 'https://res.insta360.com/static/e8799343584837c337c4e8778358e17e/2971.png',
        sceneGraph_url: 'https://res.insta360.com/static/f2ba22d276fecb4f76eb39eebc417239/SG-EN-PC-2971.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/90e456271eceff77fb8f1db824a5d07b/SG-EN-MO-2971.jpg',
      },
      {
        id: 2972,
        thumbnail_url: 'https://res.insta360.com/static/e560b3e46fdd5e175c7772854282f39d/2972.png',
        sceneGraph_url: 'https://res.insta360.com/static/344a8efa988741da4081107fec2f4885/SG-EN-PC-2972.jpeg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/0012bf3d739e9ba799a01038f1ef53b7/SG-EN-MO-2972.jpg',
      },
      {
        id: 2973,
        thumbnail_url: 'https://res.insta360.com/static/94a22504624c3b5376776a9473632728/2973.png',
        sceneGraph_url: 'https://res.insta360.com/static/4ced2c078ad981c05412a837ee0746ea/SG-EN-PC-2973.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/90ef75874ed97e2283e14a6d6e962023/SG-EN-MO-2973.jpg',
      },
      {
        id: 2974,
        thumbnail_url: 'https://res.insta360.com/static/ad3db15ce680148ccdc92d95d99536bc/2974.png',
        sceneGraph_url: 'https://res.insta360.com/static/7dfc147c0752847958c9dd272a90b8fd/SG-EN-PC-2974.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/d3e6d75c5bcb88df5e4a4f396522c45f/SG-EN-MO-2974.jpg',
      },
      {
        id: 2976,
        thumbnail_url: 'https://res.insta360.com/static/9465103a87c8356ed11241c01b50add0/2976.png',
        sceneGraph_url: 'https://res.insta360.com/static/486c33a4aa2c95142610b94f2d5e8522/SG-EN-PC-2976.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/fe5ceedaad1ba2bb3186d63202c4822c/SG-EN-MO-2976.jpg',
      },
      {
        id: 2981,
        thumbnail_url: 'https://res.insta360.com/static/71bdc491c89569eda883e16f4d97eb4c/2981.png',
        sceneGraph_url: 'https://res.insta360.com/static/521e5378ee48881ead89b1cefe43cdf9/SG-EN-PC-2981.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/6a95fad94b9b6bbfa07b98e03cc4df54/SG-EN-MO-2981.jpg',
      },
      {
        id: 2982,
        thumbnail_url: 'https://res.insta360.com/static/635cecf0bd2af065e9ad80115a8ae909/2982.png',
        sceneGraph_url: 'https://res.insta360.com/static/d2eb3dab28efa9dc544f12a0df209e27/SG-EN-PC-2982.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/c18c254cea22368d984dd3366bc925af/SG-EN-MO-2982.jpg',
      },
      {
        id: 2983,
        thumbnail_url: 'https://res.insta360.com/static/21b5cd2eb3be830e8bd163a2b0b492a2/2983.png',
        sceneGraph_url: 'https://res.insta360.com/static/8d661a655dfdd08eff44f35441673ad8/SG-EN-PC-2983.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/8e41a1cb08aafc5651d4863b8001e9de/SG-EN-MO-2983.jpg',
      },
      {
        id: 2986,
        thumbnail_url: 'https://res.insta360.com/static/c80a8445d89c696ed30e54c33f5373bd/2986.png',
        sceneGraph_url: 'https://res.insta360.com/static/6ba8247049eda0b3463b4824a7549114/SG-EN-PC-2986.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/c3d7c434d74f2ca2a9eb3bc19593fb73/SG-EN-MO-2986.jpg',
      },
      {
        id: 3443,
        thumbnail_url: 'https://res.insta360.com/static/1c84852a39d480785ef5c3fb13417558/3444.png',
        sceneGraph_url: 'https://res.insta360.com/static/af70d44ebe2210df57de18b8d3972dfc/SG-EN-PC-3443.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/e78aae92f82e30f9d7cddfb606d0f548/SG-EN-MO-3443.jpg',
      },
      {
        id: 3444,
        thumbnail_url: 'https://res.insta360.com/static/130a7698af52d16e05d0a9a920b872fa/3443.png',
        sceneGraph_url: 'https://res.insta360.com/static/63148fb90bc23c96abce453096bb9570/SG-EN-PC-3444.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/789c0de7be91f0fc2636958a802c71c5/SG-EN-MO-3444.jpg',
      },
      {
        id: 3630,
        thumbnail_url: 'https://res.insta360.com/static/c7a3d27572e2caacb9fe7c810307d8cc/3630.png',
        sceneGraph_url: 'https://res.insta360.com/static/e9777ede4c94f4852a3ca4f1d5c3262d/SG-EN-PC-3630.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/ab440985268171e24001b8951a6c32f4/SG-EN-MO-3630.jpg',
      },
      {
        id: 3785,
        thumbnail_url: 'https://res.insta360.com/static/b699ed34b349db144404ebac2634e4d1/3785.png',
        sceneGraph_url: 'https://res.insta360.com/static/82d7fa6729b34ccee3d029111cedccd9/SG-EN-PC-3785.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/2029443f5032a44183011e6b1525727e/SG-EN-MO-3785.jpg',
      },
      {
        id: 3786,
        thumbnail_url: 'https://res.insta360.com/static/11faa6fbfac4e5f3811380b46ad79af7/3786.png',
        sceneGraph_url: 'https://res.insta360.com/static/6b594019b08b5510bfc5fd433300ba38/SG-EN-PC-3786.jpg',
        sceneGraph_url_mo: 'https://res.insta360.com/static/acd496a958aac93e8fe99089b1301087/SG-EN-MO-3786.jpg',
      },
    ],
  };

  if (accessoriesList[pid].length) {
    return accessoriesList[pid].map((item) => {
      return {
        ...item,
        accessory_name: LANG[`product.x4.X4_Accessories.accessories_name_${item.id}`] ?? '',
        accessory_desc: LANG[`product.x4.X4_Accessories.accessories_desc_${item.id}`] ?? '',
      };
    });
  }

  return [];
}

/** 部分场景套餐相对于其他套餐配件有专属的场景配件列表 */
function getSceneAccessories(pid: number, cid: number, list: PointGroupType[]): PointGroupType[] {
  const sceneAccessoriesList: Record<number, Map<number[], PointGroupType>> = {
    26: new Map([
      [
        // 114cm隐形自拍杆_滑板公园-2141 房产套餐的自拍杆
        [3393, 3394],
        {
          id: 2141,
          thumbnail_url:
            'https://res.insta360.com/static/15e8d0c5d53daf7854b04aa15877298d/114cm%E9%9A%90%E5%BD%A2%E8%87%AA%E6%8B%8D%E6%9D%86.png',
          sceneGraph_url:
            'https://res.insta360.com/static/64c33808de9181de5b83d14ce982b01a/114cm%E9%9A%90%E5%BD%A2%E8%87%AA%E6%8B%8D%E6%9D%86_%E6%BB%91%E6%9D%BF%E5%85%AC%E5%9B%AD.jpg',
          sceneGraph_url_mo: 'https://res.insta360.com/static/3aef27a309185a18827e82411017a9c7/MO.jpg',
        },
      ],
      [
        // 114cm隐形自拍杆_潜水
        [3001, 3012],
        {
          id: 2141,
          thumbnail_url:
            'https://res.insta360.com/static/ab383f8eaa4c083f0189ddfb84537950/114cm%E9%9A%90%E5%BD%A2%E8%87%AA%E6%8B%8D%E6%9D%86.png',
          sceneGraph_url:
            'https://res.insta360.com/static/c467ee1cb88cad53dfe6d923f1283f07/114cm%E9%9A%90%E5%BD%A2%E8%87%AA%E6%8B%8D%E6%9D%86_%E6%BD%9C%E6%B0%B4.jpg',
          sceneGraph_url_mo: 'https://res.insta360.com/static/ee95e6e2573d7257a2c56778d9211421/MO.jpg',
        },
      ],
      [
        // 114cm隐形自拍杆_通用-2141 人气套餐get-set的 [2995, 3006]
        [2995, 3006, 2998, 3009, 3395, 3396, 3397, 3398],
        {
          id: 2141,
          thumbnail_url:
            'https://res.insta360.com/static/064fae32a5fe29a0bd7eb4ea70c1a840/114cm%E9%9A%90%E5%BD%A2%E8%87%AA%E6%8B%8D%E6%9D%86.png',
          sceneGraph_url:
            'https://res.insta360.com/static/83cfaba2b1e04ef3a2c1457426fcc8ca/114cm%E9%9A%90%E5%BD%A2%E8%87%AA%E6%8B%8D%E6%9D%86_%E9%80%9A%E7%94%A8.jpg',
          sceneGraph_url_mo: 'https://res.insta360.com/static/2d97dfd7eaf054ed8976ec45abf4e337/MO.jpg',
        },
      ],
      [
        // 高强度隐形自拍杆-2601 摩托车的自拍杆 2997、3008、3377、3378
        [2997, 3008, 3377, 3378],
        {
          id: 2601,
          thumbnail_url:
            'https://res.insta360.com/static/69f59a5a7a6996c6be6bfd8693142acc/%E9%AB%98%E5%BC%BA%E5%BA%A6%E9%9A%90%E5%BD%A2%E8%87%AA%E6%8B%8D%E6%9D%86.png',
          sceneGraph_url: 'https://res.insta360.com/static/e6dea3c9c4f72719c9e0d220ca5677c9/EN.jpg',
          sceneGraph_url_mo: 'https://res.insta360.com/static/e567013cff988341146615ffd58e069f/MO.jpg',
        },
      ],
      [
        // 自拍杆防丢绳_通用-2889 潜水套餐防丢绳
        [3001, 3012],
        {
          id: 2889,
          thumbnail_url:
            'https://res.insta360.com/static/0568caf618fe126990792ae33fa183fa/%E8%87%AA%E6%8B%8D%E6%9D%86%E9%98%B2%E4%B8%A2%E7%BB%B3.png',
          sceneGraph_url: 'https://res.insta360.com/static/d114eb10ad4e2f80aa3370b3648d0b19/EN.jpg',
          sceneGraph_url_mo: 'https://res.insta360.com/static/dd094a48e3c0895c3223c13de2f3e069/MO.jpg',
        },
      ],
      [
        // 摩托车的u型尾杆
        [3377, 3378],
        {
          id: 3630,
          thumbnail_url:
            'https://res.insta360.com/static/bb751c8a84dc7bc9ceb00e497da0c760/%E6%91%A9%E6%89%98%E8%BD%A6%E5%B0%BE%E6%9D%86%E5%A5%97%E9%A4%90.png',
          sceneGraph_url: 'https://res.insta360.com/static/09624cd6a1d8cab8b896573c70228114/EN.jpg',
          sceneGraph_url_mo: 'https://res.insta360.com/static/00602ef62db5bb3e82d55348e083657a/MO.jpg',
        },
      ],
    ]),
  };

  const tempList = list;

  for (const [cids, infos] of sceneAccessoriesList[pid]) {
    if (cids.includes(cid)) {
      const index = tempList.findIndex((item) => item.id === infos.id);
      if (index !== -1) {
        Object.assign(tempList[index], infos);
      }
    }
  }

  return tempList;
}

/** 获取全景图片 */
export function getPanoramicVideo(pid: number, cid: number): PanoramicVideoType | null {
  const panoramicVideo: Record<number, Map<number[], PanoramicVideoType>> = {
    26: new Map([
      //BMW
      [
        [3647, 3648],
        {
          img_url: 'f95c238b1244aeaf8ae4e4411f715603/%E5%85%A8%E6%99%AF%E5%9B%BE.jpeg',
          pc_cover_image:
            'https://res.insta360.com/static/e6e29941fef87a2d7c1cdeec86838f82/BMW%E6%91%A9%E6%89%98%E8%BD%A6-PC.jpg',
          mo_cover_image:
            'https://res.insta360.com/static/4f9d40cd30ef100fddb2aa050f7c4637/BMW%E6%91%A9%E6%89%98%E8%BD%A6-MO.jpg',
        },
      ],
      // 标准
      [
        [2994, 3005, 3691],
        {
          img_url: '812b3e4d4c59dfa60f462776d51ad367/biaozhun.jpg',
          pc_cover_image: 'https://res.insta360.com/static/f48971920f97e482fa64aa6ab1df9960/_biaozhun-pc.jpg',
          mo_cover_image: 'https://res.insta360.com/static/0f3f75a054fa4fb968dafafe946c4750/biaozhun-MO.jpeg',
        },
      ],
      // 旅行 - 滑翔伞
      [
        [2995, 3003, 3006, 3014],
        {
          img_url: 'a3cd111ed1bfff88906a1882d4c41747/huaxiangsan.jpg',
          pc_cover_image: 'https://res.insta360.com/static/c950c6c42824881b58330c991b80a539/huaxiangsan_pc.jpg',
          mo_cover_image: 'https://res.insta360.com/static/b3ca97010fd0f854cb8de660f09401ea/huaxiangsan_mo.jpg',
        },
      ],
      // 旅行 - 汽车
      [
        [2996, 3002, 3007, 3013, 3905],
        {
          img_url: '66d3b8ec0c73cd5ce7f5f55ec95783b4/qiche.jpg',
          pc_cover_image: 'https://res.insta360.com/static/3a25566a6c114d5ad791262fafa34238/qiche_pc.jpg',
          mo_cover_image: 'https://res.insta360.com/static/0acf7c00c6a6633f879d5001115ad409/qiche_mo.jpg',
        },
      ],
      // 摩托车（车把夹视角） 1
      [
        [3375, 3376],
        {
          img_url: 'e6f22d77f733049ac9c285f930787903/motuoche1.jpg',
          pc_cover_image: 'https://res.insta360.com/static/f5d46f68f2141a357a82d72e834c9fe7/motuoche1_pc.jpg',
          mo_cover_image: 'https://res.insta360.com/static/dee4ebe2b3d4636c40bd788640cb94f2/motuoche1_mo.jpg',
        },
      ],
      // 摩托车（尾杆视角） 2
      [
        [3377, 3378],
        {
          img_url: '95daade16e1459b688344d6fd323bb59/motuoche2.jpg',
          pc_cover_image: 'https://res.insta360.com/static/3fb5f8da6953baa2bf4a1efe13653f19/motuoche2_pc.jpg',
          mo_cover_image: 'https://res.insta360.com/static/cacd2dd30c0e9f745fcb943b4ce1cafa/motuoche2_mo.jpg',
        },
      ],
      // 摩托车Marc（车把夹视角） 3
      [
        [2997, 3008],
        {
          img_url: 'e0f52fdc464107ced98b960f173ef445/motuoche3.jpg',
          pc_cover_image: 'https://res.insta360.com/static/8c200b0120a505cdb9daf5b722327901/motuoche3_pc.jpg',
          mo_cover_image: 'https://res.insta360.com/static/9c61928a017c4969719b24453b2e29f6/motuoche3_mo.jpg',
        },
      ],
      //骑行
      [
        [2998, 3395, 3397, 3009, 3396, 3398],
        {
          img_url: 'b6c918b8d54e952c32ab3ce6d5fc7106/qixing.jpg',
          pc_cover_image: 'https://res.insta360.com/static/570ea4f0f2385c6da9efdb15d8af9bb6/qixing_pc.jpg',
          mo_cover_image: 'https://res.insta360.com/static/2f1a7757e518ecd0ba4414656a835fdf/qixing_mo.jpg',
        },
      ],
      // 滑雪 单板
      [
        [2999, 3010],
        {
          img_url: '0b1c6960668ab8fa9cd9da07300b2991/huaxue_dam.jpg',
          pc_cover_image: 'https://res.insta360.com/static/77128264068a34f682f3170eb98a9d4b/huaxue_dan_pc.jpg',
          mo_cover_image: 'https://res.insta360.com/static/3f8f45c76232f5deee2fa12a3426f6cc/huaxue_dan_mo.jpg',
        },
      ],
      //滑雪（双板）
      [
        [3000, 3011],
        {
          img_url: '86fafea4b9147b74654e2877083d7bd9/huaxue_s.jpg',
          pc_cover_image: 'https://res.insta360.com/static/e8c89cb1f42dcd7bdd8ebc2e46845e98/huaxue_s_pc.jpg',
          mo_cover_image: 'https://res.insta360.com/static/7394eec192640605cd5cb501d6b93542/huaxue_s_mo.jpg',
        },
      ],
      // 潜水
      [
        [3001, 3012],
        {
          img_url: 'e7d59360e90f565109f9a42ea847c3ac/qianshui.jpg',
          pc_cover_image: 'https://res.insta360.com/static/1d09946bb1a488dc9ebf82fb09eb33ee/qianshui_pc.jpg',
          mo_cover_image: 'https://res.insta360.com/static/e2aa58d3d0996e02a95daf19b798616d/qianshui_mo.jpg',
        },
      ],
      // 无人机
      [
        [3004, 3015],
        {
          img_url: '62b4fe0ecd32c5716383bfec6e64e30e/wurenji.jpg',
          pc_cover_image: 'https://res.insta360.com/static/2e2dc82551f80551934e2d2cf6a47f7a/wurenji_pc.jpg',
          mo_cover_image: 'https://res.insta360.com/static/9942511db92b7efc99a7546b5c702429/wurenji_mo.jpg',
        },
      ],
      // 房产
      [
        [3393, 3394],
        {
          img_url: 'bff039d41aad58dec4595b6b92e54ecf/1.7.jpg',
          pc_cover_image: 'https://res.insta360.com/static/ffc3fa248540f7045beb3488dba96fd5/fangchan_pc%20(2).jpg',
          mo_cover_image: 'https://res.insta360.com/static/d0cacbef16585902a83e1b6f5999e4cb/fangchan_mo.jpg',
        },
      ],
    ]),
  };

  if (!panoramicVideo[pid]) return null;

  // 输出全景信息
  for (const [cids, infos] of panoramicVideo[pid]) {
    if (cids.includes(cid)) {
      return infos;
    }
  }
  return null;
}

/** 获取当前套餐 */
export function getMasterVideo(
  productMainVideoList: ProductMainVideoListType[],
  cid: number
): ProductMainVideoListType[] {
  return productMainVideoList.filter((item) => {
    if (!item.commodityCondition) return true;
    return item?.commodityList?.some((id) => id === cid);
  });
}

export default {
  getFourviewConfig,
  getSceneviewConfig,
  isProductStandardCid,
  getCommodityAccessoryList,
  getPanoramicVideo,
  SPECIAL_COMMODITY,
  getMasterVideo,
};
